<template>
  <div ref="container" class="mapView overflow-x-auto overflow-y-hidden "
    v-bind:class="{ 'map-mobile-view': screenType.isMobileScreen }"
    :style="{ width: screenType.isMobileScreen ? `${screenType.mainLayoutWidth * 2 - 30}px` : '100%', marginLeft: screenType.isMobileScreen ? `-${screenType.mainLayoutWidth / 2}px` : 0, marginTop: screenType.isMobileScreen ? '-150px' : 0 }">
    <canvas ref="myCanvas"></canvas>
    <div class="bg"></div>
    <!-- eslint-disable-next-line vue/require-v-for-key -->
    <div class="item" v-for="item in jettyPositionStyle" :style="item.cardPositon" @click="handleItemClick(item)">
      <div v-if="getTarget(item)">
        <div>
          <span class="dot" :class="{ 'dot--green': getTarget(item).nominationType === 'vessel' }"></span>

          <span class="time">
            {{ getDisplayTime(getTarget(item).berthAssignTiming) }}
          </span>
        </div>

        <div class="name placeholder">{{ getTarget(item).companyName }}</div>
        <div class="name placeholder">{{ getTarget(item).vesselName }}</div>
        <div class="name">{{ getTarget(item).status }}</div>
      </div>
      <div class="notData" v-else>Not Assigned</div>

    </div>
    <!-- eslint-disable-next-line vue/require-v-for-key -->
    <div class="number" v-for="item in jettyPositionStyle" :style="{
      ...item.numerPosition,
      background:
        jettyData[item.id]?.[0] || jettyData[item.id]?.[1]
          ? '#008CDB'
          : '#B8BCCA',
    }">
      {{ item.num }}
    </div>
    <!-- eslint-disable-next-line vue/require-v-for-key -->
    <div class="line" v-for="item in jettyPositionStyle" :style="item.linePosition"></div>
    <img class="ship" v-for="item in jettyPositionStyle" :style="item.shipPosition"
      :src="require('@/assets/map-view-ship.png')" alt="Ship Icon"
      v-if="jettyData[item.id]?.[0] || jettyData[item.id]?.[1]" />
  </div>
</template>
<script>
import mapViewSrc from "@/assets/map-view-preview.png";
import mapLineBg from "@/assets/map-line.png";
import mapViewBg from "@/assets/map-view-bg.png";
import { mapState } from "vuex";
export default {
  name: "mapView",
  data() {
    return {
      mapViewSrc,
      ctx: null,
      width: null,
      imageStationHeight: 257,
      height: 600,
      jettyPositionStyle: {
        "OJPT1": {
          cardPositon: {
            top: "130px",
            left: "318px",
          },
          numerPosition: {
            top: "240px",
            left: "360px",
          },
          linePosition: {
            width: "22px",
            top: "238px",
            left: "392px",
            transform: "rotate(-90deg)",
          },
          shipPosition: {
            left: "356px",
            top: "280px",
            transform: "rotate(180deg)",
          },
          id: "OJPT1",
          num: "OJPT1",
        },
        "OJPT2": {
          cardPositon: {
            top: "350px",
            left: "100px",
          },
          numerPosition: {
            top: "374px",
            left: "308px",
          },
          linePosition: {
            width: "80px",
            left: "310px",
            top: "390px",
            transform: "rotate(-180deg)",
          },
          shipPosition: {
            left: "308px",
            top: "408px",
            transform: "rotate(180deg)",
          },
          id: "OJPT2",
          num: "OJPT2",
        },
        "OJPT3": {
          cardPositon: {
            top: "480px",
            left: "540px",
          },
          numerPosition: {
            top: "500px",
            left: "394px",
          },
          linePosition: {
            left: "540px",
            top: "520px",
            width: "76px",
            transform: "rotate(180deg)",
          },
          shipPosition: {
            left: "390px",
            top: "470px",
            transform: "rotate(180deg)",
          },
          id: "OJPT3",
          num: "OJPT3",
        },
        "OJPT4": {
          cardPositon: {
            top: "350px",
            left: "560px",
          },
          numerPosition: {
            top: "374px",
            left: "440px",
          },
          linePosition: {
            width: "50px",
            left: "560px",
            top: "390px",
            transform: "rotate(180deg)",
          },
          shipPosition: {
            left: "438px",
            top: "408px",
            transform: "rotate(180deg)",
          },
          id: "OJPT4",
          num: "OJPT4",
        },
        "J16": {
          cardPositon: {
            top: "130px",
            left: "700px",
          },
          numerPosition: {
            left: "740px",
            top: "240px",
          },
          linePosition: {
            width: "50px",
            height: "2px",
            left: "780px",
            top: "190px",
            transform: "rotate(90deg)",
          },
          shipPosition: {
            left: "746px",
            top: "280px",
            transform: "rotate(180deg)",
          },
          id: "J16",
          num: "J16",
        },
        "J17": {
          cardPositon: {
            top: "130px",
            left: "510px",
          },
          numerPosition: {
            left: "550px",
            top: "240px",
          },
          linePosition: {
            width: "50px",
            height: "2px",
            left: "590px",
            top: "190px",
            transform: "rotate(90deg)",
          },
          shipPosition: {
            left: "546px",
            top: "280px",
            transform: "rotate(180deg)",
          },
          id: "J17",
          num: "J17",
        },
      },
    };
  },
  props: {
    jettyData: {
      default() {
        return {
          "OJPT1": [],
          "OJPT2": [],
          "OJPT3": [],
          "OJPT4": [],
          "J16": [],
          "J17": [],
        };
      },
    },
  },
  methods: {
    getDisplayTime(val) {
      if (!val || val === '') return '';
      var index = val.lastIndexOf(':')
      return val.substring(0, index)
    },
    showTaget(item) {
      if (item[0] && !item?.[1]) {
        return item[0];
      }
      if (item[1] && !item?.[0]) {
        return item[1];
      }
      if (item[0] && item[1]) {
        return item[0];
      }
    },
    initCanvas() {
      let container = this.$refs.container;
      let width = container.clientWidth;
      this.width = width;
      // this.width = '1540';
      this.ctx = this.$refs.myCanvas.getContext("2d");
      this.ctx.canvas.width = width;
      this.ctx.canvas.height = this.height;
      this.ctx.clearRect(0, 0, this.width, this.height);
      // this.drawBg();
      // this.drawLine();
    },
    async drawBg() {
      let imageStation = await this.addImageProcess(
        mapViewBg,
        63, 24
        // this.width * 0.83,
        // this.imageStationHeight
      );
      this.ctx.drawImage(imageStation, 0, 0);
      let imageLine = await this.addImageProcess(
        mapLineBg,
        this.width * 0.83,
        this.imageStationHeight
      );
      this.ctx.drawImage(imageLine, 0, 0);
    },
    drawLine() {
      this.ctx.lineWidth = 5;
      let ctx = this.ctx;
      ctx.strokeStyle = "white";
      ctx.beginPath();
      ctx.moveTo(820, 240);
      ctx.lineTo(840, 445);
      ctx.stroke();
      ctx.moveTo(380, 455);
      ctx.lineTo(1000, 440);
      ctx.stroke();
      ctx.moveTo(1150, 130);
      ctx.lineTo(1250, 200);
      ctx.stroke();
      ctx.moveTo(1342, 70);
      ctx.lineTo(1122, 370);
      ctx.stroke();
      ctx.closePath();
    },
    drawJettyDot() { },
    addImageProcess(src, width, height) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.width = width;
        img.height = height;
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    },
    getTarget(item) {
      // item is the jettyPositionStyle entry
      const list = this.mergedJettyData?.[item.id] || this.jettyData?.[item.id] || [];
      return list[0] || list[1] || null;
      // if you later sort by time, return earliest here
    },

    handleItemClick(item) {
      const target = this.getTarget(item);
      if (!target) return;

      const isVessel = target.nominationType === "vessel";

      this.$router.push({
        path: isVessel ? "/vessel/index" : "/barging/index",
        query: {
          id: target.bId,
          pageStatus: 1,
        },
      });
    },
  },
  mounted() {
    this.initCanvas();

  },
  computed: {
    ...mapState(["screenType"]),

  },
};
</script>
<style lang="scss" scoped>
.mapView {
  background-color: #0a1129;
  // width: 100%;
  position: relative;
  height: 600px;

  canvas {
    position: absolute;
    z-index: 2;
  }

  .bg {
    position: absolute;
    z-index: 1;
    width: 100%;
    min-width: 1560px;
    height: 600px;
    background: linear-gradient(309.88deg,
        #177b9d 8.29%,
        rgba(145, 226, 255, 0.52) 103.93%);
    box-shadow: 0px 4px 4px 2px rgba(196, 196, 196, 0.1);

    background-image: url('../../assets/map-view-jptt.png');
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
}

.item {
  height: 90px;
  width: 170px;
  border-radius: 2px;
  position: absolute;
  padding: 3px 8px;
  background: #ffffff;
  box-shadow: 0px 4px 4px 2px rgba(196, 196, 196, 0.4);
  z-index: 4;
  align-content: center;
  overflow-x: auto;
  overflow-y: auto;
  white-space: nowrap;

  .time {
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    padding-left: 5px;
    color: #4c565c;
  }

  .dot {
    display: inline-block;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: #008CDB; // default blue
  }

  .dot--green {
    background: #2dc12a; // green for vessel
  }


  .name {
    font-size: 12px;
    line-height: 14px;
    color: #4c565c;
    align-content: center;

    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
  }

  .name:hover {
    cursor: pointer;
    /* Optional: Indicate interactivity */
  }

  .placeholder {
    height: 20px;
  }
}

.number {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 30px;

  border-radius: 10px;
  background: #2dc12a;
  color: white;
  border: 2px solid #ffffff;
  z-index: 3;
}

.line {
  position: absolute;
  transform-origin: 0 0;
  z-index: 3;
  height: 2px;
  background: white;
}

.ship {
  position: absolute;
  z-index: 3;
  height: auto;
  width: 80px;
}

.notData {
  font-size: 12px;
  text-align: center;
  line-height: 48px;
  padding: 0;
  color: #4c565c;
  // width: 130px;
  align-content: center;
}

.map-mobile-view {
  // width:930px;
  scale: 50%;
  // position: relative;
  // height: 600px;
  // margin-left:-240px ;

  canvas {
    // position: absolute;
    // z-index: 2;
  }

  .bg {
    // position: absolute;
    // z-index: 1;
    // width: 100%;
    // min-width: 1540px;
    // height: 600px;
  }
}
</style>